var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD216",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    x: 13.3333333,
    y: 0,
    width: 14.6666667,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#059170",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fill: "#E21A30",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    fill: "#FFDC44",
    mask: "url(#mask-2)",
    x: 18.6666667,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "#FFDC42",
    mask: "url(#mask-2)",
    points: "14 11.3000001 12.0407158 12.6967233 12.7636265 10.4017221 10.8298116 8.96994335 13.2358791 8.94827787 14 6.66666667 14.7641209 8.94827787 17.1701884 8.96994335 15.2363735 10.4017221 15.9592842 12.6967233"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCm);
export default __webpack_public_path__ + "static/media/CM.5ec117b6e8384689024d5b1a304fff76.svg";
export { ForwardRef as ReactComponent };